// Thin wrapper around Turndown so we can swap conversion libraries later
// without touching the composer. Configured for GitHub-flavoured markdown
// (tables, strikethrough, task lists) since users paste from Google Docs and
// Notion, which both produce GFM-friendly structures.

// @ts-expect-error — @joplin/turndown-plugin-gfm has no type declarations.
import { gfm } from "@joplin/turndown-plugin-gfm";
import TurndownService from "turndown";

let service: TurndownService | null = null;

function getService(): TurndownService {
  if (service) return service;
  service = new TurndownService({
    headingStyle: "atx",
    codeBlockStyle: "fenced",
    bulletListMarker: "-",
    emDelimiter: "*",
  });
  service.use(gfm);
  return service;
}

export function htmlToMarkdown(html: string): string {
  if (!html) return "";
  return getService().turndown(html).trim();
}
